var m = require('mithril');
var d3 = require('d3');
var io = require('../../libs/socketio');
var directPointSubscription = require('../../components/directPointSubscription');
var modal = require('../../layout/components/modal');
var heading = require('../../components/heading');
var edit = require('../../layout/components/edit');
var builderEditView = require('../../libs/builderEditView');

var gaugeChart = {};

gaugeChart.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.point = ctrl.element.out_Contains[0].in.out_Column && ctrl.element.out_Contains[0].in.out_Column.length > 0 ? ctrl.element.out_Contains[0].in.out_Column[0].in : [];
  //console.log(ctrl.point)

  ctrl.handleUpdate = function  (data) {
    if (data['@rid'] != ctrl.point['@rid'] && data.rid != ctrl.point['@rid']) {
      return
    }

    ctrl.point.time = data.time;
    ctrl.point.value = data.value;
    // To prevent conflict with form entry

    if (typeof ctrl.resize != 'function') {
      return;
    } else {
      ctrl.changeMarkerPosition();
    }

    if (modal.vm.opened()) { return }
  }

  // Subscribe
  directPointSubscription.subscribe(ctrl, ctrl.point['@rid']);
  // Renew every 20 seconds
  ctrl.renewSubscription = setInterval(
    directPointSubscription.renew.bind(directPointSubscription, ctrl, ctrl.point['@rid']),
    20000
  );
  // Handle Updates
  io.on('update', ctrl.handleUpdate);
};

gaugeChart.onremove = function () {
  clearInterval(this.renewSubscription);
  directPointSubscription.release(this);
  io.off('update', this.handleUpdate);
}

gaugeChart.config = function (ctrl) {
  return function(element, isInitialized, context) {
    if (!isInitialized) {
      var $container = d3.select('#linear-gauge');
      var width = parseFloat($container.style("width"));
      var height = parseFloat($container.style("height"));

      var gauge_h = 50;
      var chart_w = width;
      var chart_y_pos = 0;

      window.onresize = ctrl.resize;

      var text_margins = {
        top: chart_y_pos + gauge_h + 14,
        right: 10,
        bottom: 0,
        left: 10
      };

      var xScale = d3.scale.linear()
        .domain([0, 100])
        .range([0, chart_w]);
      
      var yScale = d3.scale.linear()
        .domain([0, 20])
        .range([10, 0]);

      var resultPos = xScale(ctrl.point.value || 0);

      ctrl.updateSizes = function () {
        $container = d3.select('#linear-gauge');
        //width = parseFloat($container.style("width"));
        //height = parseFloat($container.style("height"));

        //chart_w = width;
        //resultPos = xScale(ctrl.point.value);
      }

      ctrl.resize = function () {
        ctrl.updateSizes();
        var newTicks = d3.selectAll(".tick")[0];
        for (var i = 0; i <= 10; i++) {
          var tickHeight = i % 5 === 0 ? 8 : 5;
          d3.select(newTicks[i]).attr("x", i * (width / 10))
            .attr("y", gauge_h - tickHeight)
            .attr("height", tickHeight);
        }
        changeMarkerPosition();
      }

      ctrl.changeMarkerPosition = function () {
        ctrl.updateSizes();

        d3.select("line")
        .transition()
          .attr("x1", xScale(ctrl.point.value))
          .attr("y1", chart_y_pos)
          .attr("x2", xScale(ctrl.point.value))
          .attr("y2", gauge_h + chart_y_pos);

        d3.select("text").transition()
          .attr("x", xScale(ctrl.point.value))
          .text(ctrl.point.value || 0);
      }

      // Chart size -----------

      var svg = d3.select('#linear-gauge').append("svg")
        .attr("width", '100%')
        .attr("height", '100%');

      var defs = svg.append("defs");

      svg.append("g")
        .append("rect")
        .attr("x", 0)
        .attr("y", chart_y_pos)
        .attr("width", "100%")
        .attr("height", gauge_h)
        .attr('fill', '#333')

      // Setpoint Region -----------      

      var setpoint = svg.append("g");
      
      setpoint.append("rect")
        .attr("x", 220)
        .attr("y", gauge_h - gauge_h)
        .attr('fill', '#00e98f')
        .attr('stroke', '#00e98f')
        .attr("stroke-width", 0)
        .attr("width", 6)
        .attr("class", "tick")
        .attr("height", gauge_h);
      
      // Alarm Region -----------   

      var gradient = defs.append("linearGradient")
         .attr("id", "svgGradient")
         .attr("x1", "0%")
         .attr("x2", "100%")
         .attr("y1", "100%")
         .attr("y2", "100%");

      gradient.append("stop")
         .attr('class', 'start')
         .attr("offset", "0%")
         .attr("stop-color", "transparent")
         .attr("stop-opacity", 0.4);

      gradient.append("stop")
         .attr('class', 'end')
         .attr("offset", "100%")
         .attr("stop-color", "transparent")
         .attr("stop-opacity", 1);


      // if (ctrl.point) {

      // }
      var alarm = svg.append("g");
      
      alarm.append("rect")
        .attr("x", 300)
        .attr("y", gauge_h - gauge_h)
        .attr('stroke', '#ff395a')
        .attr('fill', 'url(#svgGradient)')
        .attr("stroke-width", 0)
        .attr("width", 200)
        .attr("height", gauge_h);


      // Ticks -----------

      var ticks = svg.append("g");
      for (var i = 0; i <= 20; i++) {
        var tickHeight = i % 5 === 0 ? 8 : 5;
        ticks.append("rect")
          .attr("x", i * (width / 20))
          .attr("y", gauge_h - tickHeight)
          .attr("width", 1)
          .attr("class", "tick")
          .attr("height", tickHeight);
      }

      var marker = svg.append("g");

      marker.append("line")
        .attr("x1", resultPos)
        .attr("y1", chart_y_pos)
        .attr("x2", resultPos)
        .attr("y2", gauge_h + chart_y_pos)
        .attr("stroke-width", 3)
        .attr("stroke", "white");

      marker.append("g")
        .append("text")
        .attr("x", (resultPos - 5))
        .attr("y", text_margins.top)
        .attr("style", "font-size: 14;")
        .attr("fill", "white")
        .text(Math.floor(ctrl.point.value));
    }
  }
}

gaugeChart.view = function(ctrl) {
  var ctrl = this
  return m('div', {style: {minHeight: '5em'}}, [
    m(heading, {label: ctrl.element.name, class: 'fw2 f2 pb1', element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback}),
    edit.vm.editing() ? 
      m(builderEditView, {element: ctrl.element, parentReinitialize: ctrl.parentReinitialize})
    :
      m('div', {id: 'linear-gauge', style: {height: '65px'}, oncreate: gaugeChart.config(ctrl)})
  ])
};


module.exports = gaugeChart;
